import React, { useEffect, useState } from "react";
import { Box, Button, Link, makeStyles, Typography, useMediaQuery } from "@material-ui/core";
import { MainButton } from "@shoothill/core";
import { RegisterUserViewModel } from "./RegisterUserViewModel";
import { RegisterUserModel } from "./RegisterUserModel";
import { KeyValuePair } from "@shoothill/core";
import { Grid } from "@shoothill/core";
import { TypographyX } from "@shoothill/core";
import { useObserver } from "mobx-react-lite";
import { Cell } from "@shoothill/core";
import { CustomInput, CustomRadioInput, CustomCheckbox } from "Globals/Styles/AppStyling";

const useStyles = makeStyles((theme) => ({
    grid: {
        "& > *": {
            "&:not(:last-child)": {
                marginBottom: "20px",
            },
        },
    },
    link: {
        cursor: "pointer",
        fontSize: "14px",
        "&:hover": {
            color: theme.palette.hightownBlue.light,
        },
    },
    register: {
        boxShadow: "none !important",
        "&:hover": {
            backgroundColor: `${theme.palette.primary.light} !important`,
        },
        "& .MuiTypography-body1": {
            fontSize: "14px",
            ["@media (max-width:780px)"]: {
                fontSize: "16px !important",
            },
        },
    },
}));
export const RegisterView: React.FC = () => {
    const [viewModel] = useState(() => new RegisterUserViewModel());
    const [errorMessage, setErrorMessage] = useState("");
    const bind = viewModel.getContext();
    const isMobile: boolean = useMediaQuery("screen and (max-width: 767px)") ? true : false;
    useEffect(() => {});

    const doSubmit = async (e: any) => {
        e.preventDefault();
        //isValid will check all fields to make sure they are in a valid state.
        if (!(await viewModel.isModelValid())) {
            setErrorMessage("");
        } else {
            setErrorMessage("");
            await viewModel.register();
        }
    };

    const classes = useStyles();

    return useObserver(() => (
        <Box margin="60px 5%">
            <form onSubmit={doSubmit} style={{ paddingBottom: "30px" }}>
                {errorMessage !== "" && (
                    <Typography variant="caption" style={{ color: "red" }}>
                        {errorMessage}
                    </Typography>
                )}
                <Grid className={classes.grid} desktopColumns="1fr 1fr 1fr" rowGap="20px">
                    <CustomInput<RegisterUserModel> viewModel={viewModel} label="First Name" fieldName="firstName" />
                    <CustomInput<RegisterUserModel> viewModel={viewModel} label="Last Name" fieldName="lastName" />
                </Grid>
                <CustomRadioInput
                    paddingTop="35px"
                    type="radio"
                    label="Gender"
                    viewModel={viewModel}
                    fieldName="userDetails.gender"
                    selectItems={
                        [
                            { value: "female", key: "Female" },
                            { value: "male", key: "Male" },
                            { value: "other", key: "Other" },
                        ] as KeyValuePair[]
                    }
                />
                <Grid className={classes.grid} desktopColumns="1fr 1fr 1fr" paddingTop="35px">
                    <Cell desktopSpan={2}>
                        <CustomInput<RegisterUserModel> viewModel={viewModel} label="Organization name" fieldName={bind.userDetails.companyName} />
                    </Cell>
                    <Box>
                        <CustomInput<RegisterUserModel> viewModel={viewModel} label="Position" fieldName={bind.userDetails.position} />
                    </Box>
                    <Box />
                </Grid>
                <Grid className={classes.grid} desktopColumns="1fr 1fr 1fr" paddingTop="35px">
                    <Box>
                        <CustomInput<RegisterUserModel> viewModel={viewModel} label="Company website" fieldName={bind.userDetails.companyWebsite} />
                    </Box>
                    <Box>
                        <CustomInput<RegisterUserModel> viewModel={viewModel} label="Company registration number" fieldName={bind.userDetails.companyRegNo} />
                    </Box>
                    <Box>
                        <CustomInput<RegisterUserModel> viewModel={viewModel} label="VAT number" fieldName={bind.userDetails.companyVatNo} />
                    </Box>
                    <Box />
                </Grid>
                <Grid className={classes.grid} desktopColumns="1fr 1fr 1fr 1fr" paddingTop="35px">
                    <Box>
                        <CustomInput<RegisterUserModel> viewModel={viewModel} label="Address line 1" fieldName={bind.userDetails.address1} />
                    </Box>
                    <Box>
                        <CustomInput<RegisterUserModel> viewModel={viewModel} label="Address line 2" fieldName={bind.userDetails.address2} />
                    </Box>
                    <Box>
                        <CustomInput<RegisterUserModel> viewModel={viewModel} label="Town/City" fieldName={bind.userDetails.city} />
                    </Box>
                    <Box>
                        <CustomInput<RegisterUserModel> viewModel={viewModel} label="PostCode" fieldName={bind.userDetails.postCode} />
                    </Box>
                </Grid>
                <Grid className={classes.grid} desktopColumns="1fr 1fr 1fr 1fr" paddingTop="35px">
                    <Box>
                        <CustomInput<RegisterUserModel> noFill={true} type="email" viewModel={viewModel} label="Contact email" fieldName="emailAddress" />
                    </Box>
                    <Box>
                        <CustomInput<RegisterUserModel> viewModel={viewModel} label="Contact number" fieldName="phoneNumber" />
                    </Box>
                </Grid>{" "}
                <Grid className={classes.grid} desktopColumns="1fr 1fr 1fr 1fr" paddingTop="35px">
                    <Box>
                        <CustomInput<RegisterUserModel> noFill={true} type="password" viewModel={viewModel} label="Password" fieldName="password" />
                    </Box>
                    <Box>
                        <CustomInput<RegisterUserModel> noFill={true} type="password" viewModel={viewModel} label="Confirm password" fieldName="confirmPassword" />
                    </Box>
                </Grid>
                <Box>
                    <TypographyX css="" style={{ marginTop: "30px", paddingBottom: "50px", paddingTop: "10px" }}>
                        Password must include at least 6 characters and contain one number
                    </TypographyX>
                </Box>
                <Box style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ position: "relative" }}>
                        {" "}
                        <CustomCheckbox type={"checkbox"} viewModel={viewModel} fieldName={"terms"} label={"I have read and agreed to"} />
                    </div>
                    {/* from MUI => rel="noopener" prevents the new page from being able to access the window.opener property and ensures it runs in a separate process. Without this, the target page can potentially redirect your page to a malicious URL. */}
                    <Link
                        href="https://hightown-prod.azurewebsites.net/"
                        target="_blank"
                        rel="noopener"
                        className={classes.link}
                        style={{ marginLeft: "-10px" }}
                        underline="always"
                    >
                        terms and conditions
                    </Link>
                </Box>
                <MainButton className={classes.register} buttonText={"Register and Continue"} showDivider={true} />
            </form>
        </Box>
    ));
};
